import React from "react";
import Loadable from "react-loadable";

import DotSpinner from "@exo/dot-spinner";

const IraqMapLoader = Loadable.Map({
	loader: {
		MapComponent: () => import(/* webpackChunkName: "map" */ "genericComponents/Map"),
		afghanistanMapObject: () => import(/* webpackChunkName: "map" */ "static/maps/jsMaps/afghanistan.js"),
		mapIndex: () => import(/* webpackChunkName: "map" */ "lib/maps/mapIndexAfghanistan.js"),
	},
	loading: DotSpinner,
	render(loaded, props) {
		const { actions } = props;
		const Map = loaded.MapComponent.default;
		const mapIndex = loaded.mapIndex.default;
		const afghanistanMapObject = loaded.afghanistanMapObject.default;

		return (
			<Map
				{...props}
				reactSimpleMaps={null}
				baseMapObject={afghanistanMapObject}
				states={null}
				mapIndex={mapIndex}
				baseIcon={false} // Pass a tiny map svg/js object here, or false to disable
				// trigger remount between detailed and base maps (prevents awkward transition)
				key={props.mapHighlight ? "mapHighlight" : "baseMap"}
				clearMap={actions.clearMap}
				mapHighlightDisabled={true}
				mapId="base"
				moeMode={false}
				subtractFromHeight={360}
				// actions
				clearMapPlay={actions.clearMapPlay}
				clickMap={actions.clickMap}
				hoverMap={actions.hoverMap}
				incrementMapPosition={actions.incrementMapPosition}
				setMapPosition={actions.setMapPosition}
				toggleMapPlay={actions.toggleMapPlay}
				unhoverMap={actions.unhoverMap}
			/>
		);
	},
});

export default IraqMapLoader;
